<template>
  <div class="form-group">
    <span v-if="editable" class="editIcon" @click="oeffneAngebotSucheModal"
      ><font-awesome-icon icon="fa-duotone fa-pencil-alt"
    /></span>
    <ValidationProvider
      :rules="required ? 'required' : ''"
      immediate
      v-slot="{ passed }"
      ><input v-model="angebotId" type="hidden" />
      <b-form-input
        v-model="angebotName"
        :class="{ 'border-danger': !passed }"
        readonly
        placeholder=" "
      />
      <label :class="{ 'text-danger': !passed }">{{ label }}</label>
    </ValidationProvider>

    <angebot-suche-modal @confirmed="onAngebotResult"></angebot-suche-modal>
  </div>
</template>
  
  <script>
import AngebotSucheModal from "@/newviva/components/Modale/AngebotSucheModal.vue";
import { v4 as uuid } from "uuid";

export default {
  name: "SingleSelectAngebot",
  components: { AngebotSucheModal },
  props: {
    angebot: {
      type: Object,
      required: false,
      default: function () {
        return { name: this.$t("global.notlinked") };
      },
    },
    label: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    angebotId() {
      return this.angebot?.id == null ? null : this.angebot.id;
    },
    angebotName() {
      return this.angebot?.id == null
        ? this.$t("global.notlinked")
        : this.angebot.von +
            " – " +
            this.angebot.bis +
            ", " +
            this.angebot.firma.name;
    },
  },
  methods: {
    oeffneAngebotSucheModal() {
      this.$bus.$emit("open-angebot-suche-modal");
    },

    onAngebotResult(selectedAngebot) {
      if (selectedAngebot) {
        this.$emit(
          "confirmed",
          selectedAngebot[0] ? selectedAngebot[0] : selectedAngebot
        );
      }
    },
  },
};
</script>
  